import React from "react";
import PropTypes from "prop-types";
import { OPTION_CENTER, CONTROL_CLASS, RECORD_BUTTON, STOP_RECORD_BUTTON } from "./Classes";

var RecordButton = function RecordButton(_ref) {
  var isRecording = _ref.isRecording,
      onClick = _ref.onClick;
  var buttonClass = isRecording ? STOP_RECORD_BUTTON : RECORD_BUTTON;
  return React.createElement("div", {
    className: OPTION_CENTER
  }, React.createElement("button", {
    className: "button " + CONTROL_CLASS + " " + buttonClass,
    onClick: onClick
  }));
};

RecordButton.propTypes = process.env.NODE_ENV !== "production" ? {
  isRecording: PropTypes.bool,
  onClick: PropTypes.func.isRequired
} : {};
export default RecordButton;